import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { default as dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { useUpdateCall } from '../../lib/api/update'

dayjs.extend(utc)
export const ProjectTemplate = ({
  data,
  selectedProject,
  isLocalEnvironment,
  closeSelectTemplate,
}) => {
  const [firstModal, setFirstModal] = React.useState(true)
  const [secondModal, setSecondModal] = React.useState(false)
  const [thirdModal, setThirdModal] = React.useState(false)
  const [secondModalContent, setSecondModalContent] = React.useState(null)

  const updateCallMutation = useUpdateCall()

  const setTemplateSelect = (content) => {
    setFirstModal(false)
    setSecondModal(true)
    const contentDetails = JSON.parse(content.themeDetails)
    const themeDetails = {
      img: content.themeImg,
      id: content.themeId,
      details: { ...contentDetails },
    }
    setSecondModalContent(themeDetails)
  }
  const closeTemplateDetails = () => {
    setFirstModal(true)
    setSecondModal(false)
    setSecondModalContent(null)
  }

  const nextModal = async (themeId) => {
    const payload = {
      themeId: themeId,
      websiteProjectId: selectedProject.websiteProjectId,
    }
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websiteProjects/updateTheme',
      data: payload,
      id: selectedProject.websiteProjectId,
      params: `&themeId=${themeId}&isDependency=true`,
      messageTitle: 'Website Theme',
      message: 'Website theme updated!',
      isDynamic: true,
    })
    setFirstModal(false)
    setSecondModal(false)
    setThirdModal(true)
    closeSelectTemplate()
  }

  const upateSite = async (e) => {
    e.preventDefault()
    const payload = {
      themeId: secondModalContent.themeId,
      websiteName: e.target.websiteName.value,
      websiteProjectSettings:
        '{"favicon":"https://web-resources.azureedge.net/website-templates/favicon.png"}',
      userId: '65B94E40-0D91-493D-803F-D9FA6EB526B7',
      appId: 'D4EF0DEA-FAC3-4231-8894-110C6F9C3856',
      tenantId: '679504D2-981E-45C9-9BC4-B934F1F7BA01',
    }
    await axios.post(
      'https://trf-dev-api.azurewebsites.net/websiteProjects?tenantId=679504D2-981E-45C9-9BC4-B934F1F7BA01&appId=D4EF0DEA-FAC3-4231-8894-110C6F9C3856&utcOffset=' +
        dayjs().utcOffset(),
      payload,
      {
        headers: {
          tokenSource: 'passport',
          Authorization: `Bearer eyJwYXNzcG9ydCI6eyJ1c2VyIjp7InByb2ZpbGUiOnsiaWQiOiIxMTA4NTcxMTI5ODg5NTI0ODYxNzAiLCJkaXNwbGF5TmFtZSI6IksgTWFuanUiLCJuYW1lIjp7ImZhbWlseU5hbWUiOiJNYW5qdSIsImdpdmVuTmFtZSI6IksifSwiZW1haWxzIjpbeyJ2YWx1ZSI6ImsubWFuanUudGh1bGlzaGFAZ21haWwuY29tIiwidmVyaWZpZWQiOnRydWV9XSwicGhvdG9zIjpbeyJ2YWx1ZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0tIT09QdkhIdUk0NWpHUTZLekZ2ejV4dHctTGpnQXpUb3BvNV9vT2xWWnBvYkF6dz1zOTYtYyJ9XSwicHJvdmlkZXIiOiJnb29nbGUiLCJfcmF3Ijoie1xuICBcInN1YlwiOiBcIjExMDg1NzExMjk4ODk1MjQ4NjE3MFwiLFxuICBcIm5hbWVcIjogXCJLIE1hbmp1XCIsXG4gIFwiZ2l2ZW5fbmFtZVwiOiBcIktcIixcbiAgXCJmYW1pbHlfbmFtZVwiOiBcIk1hbmp1XCIsXG4gIFwicGljdHVyZVwiOiBcImh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0tIT09QdkhIdUk0NWpHUTZLekZ2ejV4dHctTGpnQXpUb3BvNV9vT2xWWnBvYkF6d1xcdTAwM2RzOTYtY1wiLFxuICBcImVtYWlsXCI6IFwiay5tYW5qdS50aHVsaXNoYUBnbWFpbC5jb21cIixcbiAgXCJlbWFpbF92ZXJpZmllZFwiOiB0cnVlXG59IiwiX2pzb24iOnsic3ViIjoiMTEwODU3MTEyOTg4OTUyNDg2MTcwIiwibmFtZSI6IksgTWFuanUiLCJnaXZlbl9uYW1lIjoiSyIsImZhbWlseV9uYW1lIjoiTWFuanUiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUNnOG9jS0hPT1B2SEh1STQ1akdRNkt6RnZ6NXh0dy1MamdBelRvcG81X29PbFZacG9iQXp3PXM5Ni1jIiwiZW1haWwiOiJrLm1hbmp1LnRodWxpc2hhQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlfX19fSwiaWF0IjoxNzI5ODQyNzU5LCJleHAiOjE3Mjk4NDk5NTl9`,
        },
      },
    )
    setFirstModal(false)
    setSecondModal(false)
    setThirdModal(false)
  }

  const filterThemes = (e) => {
    if (e.target.value) {
      const filtered = data.themes.filter((f) => f.themeCategory === e.target.value)
      console.log(filtered.length > 0 ? filtered : 'No Themes Found!')
    }
  }

  console.log(selectedProject, isLocalEnvironment, thirdModal, upateSite)

  return (
    <>
      <div
        className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
        aria-labelledby="exampleModalLabel"
        style={{
          display: firstModal ? 'block' : 'none',
          backgroundColor: 'rgba(55,55,55,0.3)',
        }}
        aria-modal="true"
        role="dialog"
      >
        <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
          <div className="trtui-modal-content">
            <div className="trtui-modal-header trtui-bg-light trtui-p-3">
              <h5 className="trtui-modal-title" id="exampleModalLabel">
                Choose Template
              </h5>
              <button
                type="button"
                className="trtui-btn-close"
                onClick={() => {
                  closeSelectTemplate()
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ri-close-line" />
              </button>
            </div>
            <div className="trtui-modal-body">
              <select className="trtui-form-control trtui-mb-3" onChange={(e) => filterThemes(e)}>
                <option value={''}>Filter Themes</option>
                <option value="onepage">One Page</option>
                <option value="multipage">Multi Page</option>
                <option value="multipurpose">Multi Purpose</option>
              </select>
              <div className="trtui-row">
                {data.length > 0 &&
                  data.map((template, templateInd) => (
                    <div key={templateInd} className="trtui-col-sm-6 trtui-col-md-4 trtui-mb-2">
                      <div className="trtui-card">
                        <div
                          style={{
                            backgroundImage: `url(${template.themeImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            width: '230px',
                            height: '250px',
                          }}
                        ></div>
                        <div className="trtui-card-body trtui-text-center">
                          <h4 className="trtui-card-title trtui-mb-2">{template.themeName}</h4>
                          <button
                            className="trtui-btn trtui-btn-success trtui-btn-sm"
                            onClick={() => setTemplateSelect(template)}
                          >
                            Template Details
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {secondModal && (
        <div
          className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
          aria-labelledby="exampleModalLabel"
          style={{
            display: secondModal ? 'block' : 'none',
            backgroundColor: 'rgba(55,55,55,0.3)',
          }}
          aria-modal="true"
          role="dialog"
        >
          <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
            <div className="trtui-modal-content">
              <div className="trtui-modal-body trtui-bg-light" style={{ padding: 0 }}>
                <div className="trtui-card" style={{ marginBottom: 0 }}>
                  <div className="trtui-row trtui-g-0" style={{ textAlign: 'justify' }}>
                    <div className="trtui-col-md-4">
                      <img
                        className="trtui-rounded-start trtui-img-fluid trtui-h-100 trtui-object-fit-cover"
                        src={secondModalContent.img || null}
                        alt="Card image"
                      />
                    </div>
                    <div className="trtui-col-md-8">
                      <div className="trtui-card-header">
                        <h5 className="trtui-card-title trtui-mb-0">
                          {secondModalContent.details?.name || null}
                        </h5>
                      </div>
                      <div className="trtui-card-body">
                        <p className="trtui-card-text mb-2">
                          {secondModalContent.details?.description || null}
                        </p>
                        <p className="trtui-card-text trtui-text-left">
                          <ul>
                            {secondModalContent.details?.features.length > 0 &&
                              secondModalContent.details?.features.map((feature, featureInd) => (
                                <li key={featureInd}>{feature}</li>
                              ))}
                          </ul>
                        </p>
                        <p className="trtui-card-text mb-2">
                          <h5 className="trtui-text-danger">
                            Warning: If you are changing theme for your website you will loose
                            website settings and content of all of your pages, however the pages
                            will remain as it is.
                          </h5>
                        </p>
                        <div className="trtui-text-end">
                          <button
                            className="trtui-btn trtui-btn-info trtui-float-right"
                            onClick={closeTemplateDetails}
                          >
                            Preview
                          </button>{' '}
                          <button
                            className="trtui-btn trtui-btn-primary trtui-float-right"
                            onClick={() => nextModal(secondModalContent.id)}
                          >
                            Use this template
                          </button>{' '}
                          <button
                            className="trtui-btn trtui-btn-light trtui-float-right"
                            onClick={closeTemplateDetails}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

ProjectTemplate.propTypes = {
  closeSelectTemplate: PropTypes.func.isRequired,
  selectedProject: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
}
